module.exports = __webpack_public_path__ + "img/d4.ed988081.png";